import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.styleClasses,attrs:{"id":"app"}},[_c(VApp,[_c('app-version-hint'),_c('local-storage-hint'),_c('app-header'),_c(VMain,[_c('breadcrumb'),_c(VContainer,{staticClass:"main-container",attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('snackbar')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }